// CertNZ Address Fix v1 - Prevents parcel auto-selection from overwriting user's address
// Bug: User selects "17 Bell Common Close" -> parcel loads -> address becomes "15 Bell Common Close"
// Fix: Remember user's explicit selection and preserve it

(function() {
  'use strict';
  
  // Track if user explicitly selected an address from dropdown
  window._userExplicitAddress = null;
  
  // Patch selectAddr
  const _origSelectAddr = window.selectAddr;
  window.selectAddr = function(i) {
    const addr = window.addrResults && window.addrResults[i];
    if (addr) {
      window._userExplicitAddress = addr.full_address;
      console.log('[Fix] User selected:', window._userExplicitAddress);
    }
    return _origSelectAddr ? _origSelectAddr(i) : null;
  };
  
  // Clear on new input
  const inp = document.getElementById('addressInput');
  if (inp) {
    inp.addEventListener('input', () => { window._userExplicitAddress = null; });
  }
  
  // Observe propAddress changes and restore if needed
  const prop = document.getElementById('propAddress');
  if (prop) {
    new MutationObserver((muts) => {
      if (!window._userExplicitAddress) return;
      const cur = prop.textContent || '';
      if (cur === window._userExplicitAddress || cur.includes('...') || cur.includes('Loading')) return;
      
      // Same street, different number? Restore.
      const userNum = (window._userExplicitAddress.match(/^(\d+)/) || [])[1];
      const curNum = (cur.match(/^(\d+)/) || [])[1];
      const userStreet = window._userExplicitAddress.replace(/^\d+\s*/, '').toLowerCase().trim();
      const curStreet = cur.replace(/^\d+\s*/, '').toLowerCase().trim();
      
      if (userStreet === curStreet && userNum !== curNum) {
        console.log('[Fix] Restoring address from', cur, 'to', window._userExplicitAddress);
        prop.textContent = window._userExplicitAddress;
        if (inp) inp.value = window._userExplicitAddress;
        try {
          localStorage.setItem('certnz_address', window._userExplicitAddress);
          localStorage.setItem('selectedAddress', window._userExplicitAddress);
        } catch(e) {}
      }
    }).observe(prop, { childList: true, subtree: true, characterData: true });
  }
  
  console.log('[CertNZ] Address fix v1 loaded');
})();
